import React, { FC, useState } from 'react';
import styles from './headerForStage.module.scss';
import COButton from '../COButton';
import COAlertModal from '../COAlertModal';
import { stagesHeaderConstants } from 'constants/FarmboxConstants/stage0.constants';
import useRedirect from 'shared/utils/useRedirect';
import isProductDisabled from 'shared/utils/isProductDisabled';
import { useParams } from 'react-router-dom';

interface HeaderForStagesProps {
  commodityName: string;
  draftLoading: boolean;
  handleCloseCancelModal: () => void;
  handleConfirmCancelModal: () => void;
  saveCallback?: () => void;
  infoCallback?: () => void;
  loading?:boolean
}

const HeaderForStages: FC<HeaderForStagesProps> = props => {
  const {
    commodityName,
    draftLoading,
    saveCallback,
    infoCallback,
    handleCloseCancelModal,
    handleConfirmCancelModal,
    loading
  } = props;
  const { navigateBack } = useRedirect();
  const { status } = useParams();
  const [cancelModalState, setCancelModalState] = useState<boolean>(false);
  const { CANCEL_MODEL, COMMODITY_INFO } = stagesHeaderConstants;
  const { SAVE, CLOSE, DESCRIPTION } = CANCEL_MODEL;
  const handleCloseModal = () => setCancelModalState(false);
  const cancelCallback = () => setCancelModalState(true);
  const handleTopBackButton = () => navigateBack();
  const isDisabled = isProductDisabled(status);

  return (
    <div className={styles.headerContainer}>
      <div className={styles.headerDetailsContainer}>
        <div>
          <span className={styles.commodityName}>{commodityName}</span>
        </div>
        <div className={styles.infoButton} onClick={infoCallback}>
          {COMMODITY_INFO}
        </div>
      </div>
      <div className={styles.headerActionsContainer}>
        {isDisabled ? (
          <COButton text onClick={handleTopBackButton}>
            Back
          </COButton>
        ) : (
         !loading && <>
            <COButton onClick={cancelCallback} text>
              Cancel
            </COButton>
            <COButton onClick={saveCallback} secondary loading={draftLoading}>
              Save as draft
            </COButton>
          </>
        )}
      </div>
      <COAlertModal
        handleModalCancel={handleCloseCancelModal}
        handleModalConfirm={handleConfirmCancelModal}
        onModalCancel={handleCloseModal}
        showModalState={cancelModalState}
        alertModal
        confirmLabel={CLOSE}
        cancelLabel={SAVE}
        heading={DESCRIPTION}
      />
    </div>
  );
};

export default HeaderForStages;
